export default {
  'admin.marketplace.title': 'אוצרות שוק',
  'admin.marketplace.search': 'חיפוש לפי שם',
  'admin.marketplace.filters.all': 'הכל',
  'admin.marketplace.filters.featured': 'מומלצים',
  'admin.marketplace.empty': 'אין מנויים ציבוריים שמתאימים למסננים.',
  'admin.marketplace.column.name': 'שם',
  'admin.marketplace.column.owner': 'בעלים',
  'admin.marketplace.column.total': 'מחיר כולל',
  'admin.marketplace.column.features': 'פיצ׳רים',
  'admin.marketplace.column.clones': 'שכפולים',
  'admin.marketplace.column.public': 'ציבורי',
  'admin.marketplace.column.featured': 'מומלץ',
  'admin.marketplace.column.created': 'נוצר',
  'admin.marketplace.publicYes': 'ציבורי',
  'admin.marketplace.toggle.success': 'דגל המומלץ עודכן',
  'admin.marketplace.toggle.error': 'עדכון דגל המומלץ נכשל',
  'admin.marketplace.features.title': 'אוצרות שוק תכונות',
  'admin.marketplace.features.empty': 'אין תכונות ציבוריות שמתאימות למסננים.',
  'admin.marketplace.features.column.title': 'כותרת',
  'admin.marketplace.features.column.price': 'מחיר',
};
